import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Parallax } from 'react-scroll-parallax';

import ImageContainer from '../ImageContainer';

import { getParallaxValue } from '../../helpers/getParallaxValue';

import './styles/branding.scss';

class Branding extends Component {

  render() {

    const {
      screen,
    } = this.props;

    return(
      <div className="branding">
        <div className="container-inner">
          <div className="branding__title">
            <h2>Do Deep Tech Branding</h2>
          </div>
          <div className="branding__desc">
            <div className="branding__desc__text">
              <p>Go&nbsp;where others fear to&nbsp;tread.</p>
              <p>Right now, everyone&rsquo;s investing in&nbsp;fast development and technologies, meanwhile real (deep) tech takes serious time, thought, and effort. But only deep tech can help&nbsp;us solve the problems facing humanity.</p>
              <p>The Do&nbsp;Deep Tech logo is&nbsp;a&nbsp;symbol of&nbsp;depth, movement in&nbsp;perspective, a&nbsp;portal.</p>
            </div>
          </div>
        </div>
        <div className="container-medium">
          <img src={require('../../static/images/branding/image-1.jpg').default} alt="" className="_big" />
        </div>
        <div className="container-inner">
          <div className="branding__about gallery gallery--fourth">
            <div className="gallery__content">
              <div className="gallery-container">
                <Parallax y={getParallaxValue(screen, 4, 1)}  className="image-container _medium _right _up">
                  <span>Moodboard</span>
                  <ImageContainer src={require('../../static/images/branding/image-2.jpg').default} />
                </Parallax>
                <Parallax y={getParallaxValue(screen, 4, 2)} className="image-container _small _down">
                  <ImageContainer src={require('../../static/images/branding/image-3.jpg').default} alt="" />
                  <span>Source: <a href="https://www.brainpickings.org/2019/08/20/amedee-guillemin-le-monde-physique/?utm_source=feedburner&utm_medium=feed&utm_campaign=Feed%3A+brainpickings%2Frss+%28Brain+Pickings%29" rel="noreferrer noopener" target="_blank">Brainpickings</a></span>
                </Parallax>
              </div>
              <div className="gallery-container">
                <div className="text-container _medium">
                  <p>The Do&nbsp;Deep Tech logo draws on&nbsp;the concepts of&nbsp;"movement," "depth" and "immersion" and the idea that geometry, formulas and numbers are at&nbsp;the heart of&nbsp;everything, incorporating the imagery of&nbsp;geometric shapes, sound waves and their movement, vibrations, and precise mathematical diagrams.</p>
                </div>
              </div>
              <div className="gallery-container">
                <Parallax y={getParallaxValue(screen, 4, 3)} className="image-container _medium _down">
                  <ImageContainer src={require('../../static/images/branding/image-4.jpg').default} />
                  <span>Source: <a href="https://patternbase.tumblr.com/post/111865847459/chaosophia218-composition-of-harmonic-curves" rel="noreferrer noopener" target="_blank">The Patternbase Digital Archive</a></span>
                </Parallax>
                <Parallax y={getParallaxValue(screen, 4, 4)} className="image-container _medium _right _up">
                  <span>Source: <a href="https://www.pinterest.ch/pin/485685141065042449/" rel="noreferrer noopener" target="_blank">Valam Constructions</a></span>
                  <ImageContainer src={require('../../static/images/branding/image-5.jpg').default} alt="" />
                </Parallax>
                <Parallax y={getParallaxValue(screen, 4, 5)} className="image-container _small _down">
                  <ImageContainer src={require('../../static/images/branding/image-6.jpg').default} alt="" />
                  <span>Source: <a href="https://pro-vladimir.livejournal.com/328016.html" rel="noreferrer noopener" target="_blank">Livejournal</a></span>
                </Parallax>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    screen: state.screen.screen,
  }
}

export default connect(mapStateToProps, null)(Branding);